function o() {
}
export {
  o as default
};
